/**
 * An array of objects that communicate the type, reason, and access of data that is used
 * Modify this array for each new application.
 * If no data is collected, the array should be empty.
 * @note This example data is from the wr-341-workshop application.
 * @type {Array<Object>}
 */
export const collectedData = [
  // ---- Structure and word your entries like the commented-out ones below ----------------
  // {
  //   collectionType: "Full Name",
  //   collectionReason: "Collaboration and Grading",
  //   collectionAccess: "Classmates, Instructors, Support Staff"
  // },
  // {
  //   collectionType: "Discussion Posts",
  //   collectionReason: "Collaboration and Grading",
  //   collectionAccess: "Classmates, Instructors, Support Staff"
  // },
  // {
  //   collectionType: "Document Submissions",
  //   collectionReason: "Collaboration and Grading",
  //   collectionAccess: "Classmates, Instructors, Support Staff"
  // }
];
